// extracted by mini-css-extract-plugin
module.exports = {"item":"SolutionsNavItem_item__tFSJc","icon":"SolutionsNavItem_icon__bI1Yw"};